import { ERROR_AUTOCLOSE_TIMEOUT_MS } from 'Constants';
import React, { useState } from 'react';

import EditTestDescription from '../../../SingleTest/Modals/TestEditModals/EditTestDescription';

import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

import tests from 'Api/tests';

import { useProjectContext } from 'Components/SingleProject/context';

import { useIsMounted } from 'Context';

import { getErrorMessageFromResponse, isValidResponse } from 'Utils';

export default function EditTestDescriptionBtn({
  afterEdit,
  testId,
  testDescription,
  disabled,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const mounted = useIsMounted();
  const { setMainError } = useProjectContext();

  const updateTestDescription = async (values) => {
    setSaveInProgress(true);
    let isSuccess = false;
    const testEditData = { overview: values.overview };

    try {
      const res = await tests.updateOneTest(testId, testEditData);
      if (!isValidResponse(res)) {
        throw new Error(getErrorMessageFromResponse(res));
      }
      isSuccess = true;
    } catch (err) {
      console.log('Save test description error: ', err);
      setMainError(err?.message || `Couldn't save test description`);
      setTimeout(() => setMainError(''), ERROR_AUTOCLOSE_TIMEOUT_MS);
    } finally {
      if (mounted.current) {
        setSaveInProgress(false);
        if (isSuccess) {
          setModalOpen(false);
        }
      }

      afterEdit();
    }
  };

  return (
    <React.Fragment>
      <IconButton
        aria-label="Edit test name"
        size="small"
        sx={{ mr: 1 }}
        onClick={() => setModalOpen(true)}
        disabled={disabled}
      >
        <EditIcon fontSize="inherit" />
      </IconButton>
      <EditTestDescription
        testDescription={testDescription}
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        onSubmit={(values) => updateTestDescription(values)}
        actionsDisabled={saveInProgress}
      />
    </React.Fragment>
  );
}
